import { EXTERNAL_BILLING_STRATEGIES } from 'common/utils/constants/billing';

export const getExternalBillingStatus = (strategyId) => (
  Object.keys(EXTERNAL_BILLING_STRATEGIES).includes(strategyId?.toString())
);

export default null;
